import { render, staticRenderFns } from "./ApDocumentList.vue?vue&type=template&id=59565a95&scoped=true"
import script from "./ApDocumentList.vue?vue&type=script&lang=js"
export * from "./ApDocumentList.vue?vue&type=script&lang=js"
import style0 from "./ApDocumentList.vue?vue&type=style&index=0&id=59565a95&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59565a95",
  null
  
)

export default component.exports